import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";
import { BillingPeriod, SubscriptionEstimationApi } from "../../../api/types";
import FormatMoney from "../../Formatters/FormatMoney";

interface Props {
	estimatedFeature: SubscriptionEstimationApi;
	accountsUrl: string;
	companyId: string;
}

const SubscriptionBasedRestrictionModalPlanPrice = ({ estimatedFeature, accountsUrl, companyId }: Props) => {
	const { t } = useTranslation();
	const { show } = useIntercom();
	const billingPeriodTranslation =
		estimatedFeature.billing_period === BillingPeriod.MONTHLY
			? t("lib:go_core.subscription_based_restriction.monthly.title")
			: t("lib:go_core.subscription_based_restriction.yearly.title");

	const handleGoToSubscription = () => {
		window.location.href = `${accountsUrl}/${companyId}/subscriptions/edit?plan=${estimatedFeature.required_plan}`;
	};

	return (
		<div>
			<hr />
			<div className="d-flex flex-column text-center align-items-center">
				<div className="d-flex align-items-center gap-1 mb-1">
					<h6 className="mb-0">
						{`+${FormatMoney(estimatedFeature.price_delta)}/${billingPeriodTranslation}`}
					</h6>
					<small className="text-muted">
						{`(${t("lib:go_core.subscription_based_restriction.total_price.title")} ${FormatMoney(
							estimatedFeature.total_price
						)}/${billingPeriodTranslation})`}
					</small>
				</div>
				<small className="text-muted">
					{t("lib:go_core.subscription_based_restriction.pay_at_the_end_of_month.title")}
				</small>
				<div className="mt-3">
					<Button onClick={handleGoToSubscription}>
						{t("lib:go_core.subscription_based_restriction.go_to_subscription.title")}
					</Button>
					<p className="my-2 text-muted">{t("lib:common.word.or")}</p>
					<Button variant="link" onClick={show} className="text-decoration-none">
						{t("lib:go_core.subscription_based_restriction.contact_with_us.title")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionBasedRestrictionModalPlanPrice;
